"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  changeLanguage: true,
  LanguageSwitcherPopup: true,
  useLanguageSwitcherTranslations: true
};
Object.defineProperty(exports, "LanguageSwitcherPopup", {
  enumerable: true,
  get: function () {
    return _LanguageSwitcherPopup.LanguageSwitcherPopup;
  }
});
Object.defineProperty(exports, "changeLanguage", {
  enumerable: true,
  get: function () {
    return _changeLanguage.changeLanguage;
  }
});
Object.defineProperty(exports, "useLanguageSwitcherTranslations", {
  enumerable: true,
  get: function () {
    return _useTranslations.useTranslations;
  }
});
var _models = require("./models");
Object.keys(_models).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _models[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _models[key];
    }
  });
});
var _changeLanguage = require("./utils/changeLanguage");
var _LanguageSwitcherPopup = require("./containers/LanguageSwitcherPopup");
var _constants = require("./constants");
Object.keys(_constants).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _constants[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _constants[key];
    }
  });
});
var _constantsGenerated = require("./constants-generated");
Object.keys(_constantsGenerated).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _constantsGenerated[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _constantsGenerated[key];
    }
  });
});
var _defaultTranslations = require("./constants/defaultTranslations");
Object.keys(_defaultTranslations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _defaultTranslations[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _defaultTranslations[key];
    }
  });
});
var _defaultTranslationsWithNamespaces = require("./constants/defaultTranslationsWithNamespaces");
Object.keys(_defaultTranslationsWithNamespaces).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _defaultTranslationsWithNamespaces[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _defaultTranslationsWithNamespaces[key];
    }
  });
});
var _useTranslations = require("./hooks/useTranslations");
